export const appFetch = async (
  input: RequestInfo | URL,
  authHeader?: string,
  init?: RequestInit
) => {
  const modifiedInput = modifyInput(input)

  if (authHeader) {
    assertTrustedHost(modifiedInput)
  }

  const modifiedHeaders = modifyHeaders(init?.headers ?? {}, authHeader)

  const modifiedInit = {
    ...init,
    headers: modifiedHeaders,
  }
  return await fetch(modifiedInput, modifiedInit)
}

const modifyHeaders = (headers: HeadersInit, authHeader?: string) => {
  if (authHeader) {
    return {
      Authorization: authHeader,
      ...headers,
    }
  } else {
    return headers
  }
}

const modifyInput = (input: RequestInfo | URL) => {
  if (typeof input === 'string' && !isValidHttpUrl(input)) {
    const config = useRuntimeConfig().public
    return new URL(input, config.servicesBaseURL).toString()
  } else {
    return input
  }
}

function assertTrustedHost(input: RequestInfo | URL) {
  const config = useRuntimeConfig().public
  const trustedHost = new URL(config.servicesBaseURL).host
  const resolvedHost = new URL(input.toString()).host

  if (resolvedHost !== trustedHost) {
    throw new Error('Authenticated requests must target servicesBaseURL')
  }
}

// https://stackoverflow.com/a/43467144
function isValidHttpUrl(string: string) {
  let url
  try {
    url = new URL(string)
  } catch {
    return false
  }
  return url.protocol === 'http:' || url.protocol === 'https:'
}
